import { reviews as $reviews } from '~/services/reviews'

export const REVIEWS_QUERY_KEYS = {
  root: (locale: string) => [locale, 'reviews'] as const,
  product: (locale: string, productId: string) => [...REVIEWS_QUERY_KEYS.root(locale), 'product', productId] as const,
}

export const useReviewsQuery = defineQuery(() => {
  const { locale } = useI18n()

  const { state, ...rest } = useQuery({
    key: () => [locale.value, 'reviews'],
    enabled: import.meta.client,
    query: async () => $reviews({
      options: {
        sort: {
          createdAt: 'DESC',
        },
        take: 3,
        skip: 0,
      },
    }),
  })

  return {
    ...rest,
    reviews: state,
  }
})
